import { useEffect, useRef } from 'react'

export default function FraudSection() {
  const sectionRef = useRef(null)

  useEffect(() => {
    const sec = sectionRef.current
    if (!sec) return
    let tx = 50, ty = 50, cx = 50, cy = 50, raf = null
    const tick = () => {
      cx += (tx - cx) * 0.15
      cy += (ty - cy) * 0.15
      sec.style.setProperty('--mcx', cx.toFixed(2) + '%')
      sec.style.setProperty('--mcy', cy.toFixed(2) + '%')
      if (Math.abs(tx - cx) > 0.1 || Math.abs(ty - cy) > 0.1) {
        raf = requestAnimationFrame(tick)
      } else { raf = null }
    }
    const onMove = (e) => {
      const r = sec.getBoundingClientRect()
      tx = ((e.clientX - r.left) / r.width) * 100
      ty = ((e.clientY - r.top) / r.height) * 100
      if (raf === null) raf = requestAnimationFrame(tick)
    }
    const onLeave = () => {
      tx = 50; ty = 50
      if (raf === null) raf = requestAnimationFrame(tick)
    }
    sec.addEventListener('pointermove', onMove, { passive: true })
    sec.addEventListener('pointerleave', onLeave)
    return () => {
      sec.removeEventListener('pointermove', onMove)
      sec.removeEventListener('pointerleave', onLeave)
      if (raf !== null) cancelAnimationFrame(raf)
    }
  }, [])

  return (
    <section ref={sectionRef} className="sf-mid-cta">
      <div className="sf-mid-cta-inner sf-reveal" data-sf-reveal>
        <div className="sf-mid-cta-text">
          <h3>Curious how it&rsquo;d run on your traffic?</h3>
          <p>
            Get a guided walkthrough of the architecture, watch SecureFlow run against
            real payment messages, and ask whatever you need to.
          </p>
        </div>
        <div className="sf-mid-cta-btns">
          <a href="#demo" className="sf-btn sf-btn-blue">
            <span>Book a demo</span>
            <svg className="sf-arrow" width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M3 7h8m-3-3l3 3-3 3" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </a>
          <a href="#thought" className="sf-btn sf-btn-ghost-light">See the verdict engine</a>
        </div>
      </div>

      <style jsx>{`
        .sf-mid-cta {
          --mcx: 50%; --mcy: 50%;
          background: linear-gradient(180deg,rgba(10,18,38,1) 0%,rgba(6,12,28,1) 100%);
          padding: clamp(56px,7vw,84px) 0;
          position: relative; overflow: hidden; isolation: isolate;
        }
        .sf-mid-cta::before {
          content: ''; position: absolute; inset: 0;
          background: radial-gradient(540px 360px at var(--mcx) var(--mcy),
            rgba(14,165,233,0.28) 0%,
            rgba(34,197,94,0.10) 40%,
            transparent 72%);
          pointer-events: none;
          opacity: 0;
          transition: opacity 0.45s var(--ease);
          z-index: -1;
        }
        .sf-mid-cta:hover::before { opacity: 1; }
        .sf-mid-cta::after {
          content: ''; position: absolute; inset: 0;
          background:
            radial-gradient(70% 60% at 50% 0%,rgba(14,165,233,0.06),transparent 70%),
            radial-gradient(50% 60% at 100% 100%,rgba(34,197,94,0.04),transparent 70%);
          pointer-events: none;
          z-index: -2;
        }
        .sf-mid-cta-inner {
          max-width: 1080px; margin: 0 auto; padding: 0 var(--gutter);
          display: flex; align-items: center; justify-content: space-between;
          gap: 32px; flex-wrap: wrap;
          position: relative; z-index: 1;
        }
        .sf-mid-cta-text { flex: 1; min-width: 280px; }
        .sf-mid-cta-text h3 {
          font-size: clamp(1.25rem,2.4vw,1.75rem);
          font-weight: 600; letter-spacing: -0.02em;
          line-height: 1.2; color: var(--text-light);
        }
        .sf-mid-cta-text p {
          margin-top: 8px; font-size: 14.5px;
          color: var(--text-light-2); line-height: 1.6; max-width: 54ch;
        }
        .sf-mid-cta-btns {
          display: flex; align-items: center; gap: 10px;
          flex-shrink: 0; flex-wrap: wrap;
        }
        @media (max-width: 720px) {
          .sf-mid-cta { margin: 32px 0; }
        }
      `}</style>
    </section>
  )
}
